const BackgroundPattern = () => {
  return (
    <svg width="1101" height="1032" viewBox="0 0 1101 1032">
      <g
        id="Custom_Size_1"
        data-name="Custom Size – 1"
        clip-path="url(#clip-Custom_Size_1)"
      >
        <rect width="1101" height="1032" fill="none" />
        <g
          id="undraw_developer_activity_re_39tg"
          transform="translate(150.461 111)"
        >
          <g
            id="Background"
            transform="translate(-46.876 71.43)"
            opacity="0.59"
          >
            <path
              id="Path_1"
              data-name="Path 1"
              d="M941.609,465.125a354.21,354.21,0,0,1-98.85,245.9q-5.745,6.015-11.8,11.74-9.225,8.775-19.07,16.87a353.934,353.934,0,0,1-217.58,80.69q-3.975.09-7.98.09c-63.43,0-143.21-33.88-215.61-80.78q-8.985-5.82-17.81-11.91-4.125-2.82-8.21-5.72a730.442,730.442,0,0,1-79.32-64.8,514.106,514.106,0,0,1-45.75-48.92c-55.63-68.62-67.9-130.45,11.41-143.16q14.085-2.25,27.34-4.81,19.2-3.69,36.75-7.97,23.64-5.745,44.42-12.46,6.99-2.25,13.66-4.59c65.74-23.09,109.74-53.2,139.69-85.87q7.62-8.295,14.05-16.79a236.057,236.057,0,0,0,17.83-27.12,254.9,254.9,0,0,0,18.41-41.05l.27-.78c23.83-68.74,16.58-132.5,42.87-153.84,112.38-91.23,252.29,38.69,317.96,191.9q4.965,11.58,9.34,23.3,1.965,5.235,3.79,10.49,4.8,13.695,8.71,27.46,1.5,5.25,2.86,10.49c.97,3.77,1.9,7.53,2.76,11.29C938.139,412.3,941.609,439.455,941.609,465.125Z"
              transform="translate(-174.731 -79.586)"
              fill="#f2f2f2"
            />
          </g>
          <g id="code" transform="translate(402.238 180.05)">
            <path
              id="Path_3"
              data-name="Path 3"
              d="M601.829,259.635h-22.26a2.6,2.6,0,0,0-2.6,2.6V284.5a2.593,2.593,0,0,0,2.6,2.59h22.26a2.6,2.6,0,0,0,2.6-2.59v-22.27A2.608,2.608,0,0,0,601.829,259.635Z"
              transform="translate(-576.969 -259.635)"
              fill="#fff"
            />
            <path
              id="Path_4"
              data-name="Path 4"
              d="M601.829,297.585h-22.26a2.6,2.6,0,0,0-2.6,2.6v22.27a2.592,2.592,0,0,0,2.6,2.59h22.26a2.6,2.6,0,0,0,2.6-2.59v-22.27A2.608,2.608,0,0,0,601.829,297.585Z"
              transform="translate(-576.969 -259.635)"
              fill="#e6e6e6"
            />
            <path
              id="Path_5"
              data-name="Path 5"
              d="M601.829,335.535h-22.26a2.6,2.6,0,0,0-2.6,2.6V360.4a2.595,2.595,0,0,0,2.6,2.6h22.26a2.6,2.6,0,0,0,2.6-2.6v-22.26A2.608,2.608,0,0,0,601.829,335.535Z"
              transform="translate(-576.969 -259.635)"
              fill="#e6e6e6"
            />
            <path
              id="Path_6"
              data-name="Path 6"
              d="M604.389,375.625a2.617,2.617,0,0,0-2.56-2.14h-22.26a2.6,2.6,0,0,0-2.6,2.6v22.26a2.595,2.595,0,0,0,2.6,2.6h22.26a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.311,2.311,0,0,0-.04-.46Z"
              transform="translate(-576.969 -259.635)"
              fill="#e6e6e6"
            />
            <path
              id="Path_7"
              data-name="Path 7"
              d="M602.839,411.635a2.634,2.634,0,0,0-1.01-.2h-22.26a2.595,2.595,0,0,0-2.6,2.6v22.26a2.588,2.588,0,0,0,2.6,2.6h22.26a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.616,2.616,0,0,0-1.59-2.4Z"
              transform="translate(-576.969 -259.635)"
              fill="#e6e6e6"
            />
            <path
              id="Path_8"
              data-name="Path 8"
              d="M648.589,259.635h-22.26a2.6,2.6,0,0,0-2.6,2.6V284.5a2.593,2.593,0,0,0,2.6,2.59h22.26a2.6,2.6,0,0,0,2.6-2.59v-22.27a2.608,2.608,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#e6e6e6"
            />
            <path
              id="Path_9"
              data-name="Path 9"
              d="M648.589,297.585h-22.26a2.6,2.6,0,0,0-2.6,2.6v22.27a2.592,2.592,0,0,0,2.6,2.59h22.26a2.6,2.6,0,0,0,2.6-2.59v-22.27a2.607,2.607,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_10"
              data-name="Path 10"
              d="M648.589,335.535h-22.26a2.6,2.6,0,0,0-2.6,2.6V360.4a2.595,2.595,0,0,0,2.6,2.6h22.26a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.608,2.608,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_11"
              data-name="Path 11"
              d="M648.589,373.485h-22.26a2.593,2.593,0,0,0-2.46,1.78,2.477,2.477,0,0,0-.14.82v22.26a2.595,2.595,0,0,0,2.6,2.6h22.26a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.608,2.608,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_12"
              data-name="Path 12"
              d="M648.589,411.435h-22.26a2.595,2.595,0,0,0-2.6,2.6V436.3a2.595,2.595,0,0,0,2.6,2.6h22.26a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.6,2.6,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#e6e6e6"
            />
            <path
              id="Path_13"
              data-name="Path 13"
              d="M695.349,259.635h-22.26a2.6,2.6,0,0,0-2.6,2.6V284.5a2.593,2.593,0,0,0,2.6,2.59h22.26a2.6,2.6,0,0,0,2.6-2.59v-22.27a2.608,2.608,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#2978b5"
            />
            <path
              id="Path_14"
              data-name="Path 14"
              d="M695.349,297.585h-22.26a2.6,2.6,0,0,0-2.6,2.6v22.27a2.592,2.592,0,0,0,2.6,2.59h22.26a2.6,2.6,0,0,0,2.6-2.59v-22.27a2.607,2.607,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_15"
              data-name="Path 15"
              d="M695.349,335.535h-22.26a2.6,2.6,0,0,0-2.6,2.6V360.4a2.595,2.595,0,0,0,2.6,2.6h22.26a2.6,2.6,0,0,0,2.6-2.6v-22.26A2.608,2.608,0,0,0,695.349,335.535Z"
              transform="translate(-576.969 -259.635)"
              fill="#e6e6e6"
            />
            <path
              id="Path_16"
              data-name="Path 16"
              d="M695.349,373.485h-22.26a2.6,2.6,0,0,0-2.6,2.6v22.26a2.595,2.595,0,0,0,2.6,2.6h22.26a2.6,2.6,0,0,0,2.6-2.6v-22.26A2.608,2.608,0,0,0,695.349,373.485Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_17"
              data-name="Path 17"
              d="M695.349,411.435h-22.26a2.595,2.595,0,0,0-2.6,2.6V436.3a2.595,2.595,0,0,0,2.6,2.6h22.26a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.6,2.6,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_18"
              data-name="Path 18"
              d="M742.109,259.635h-22.26a2.6,2.6,0,0,0-2.6,2.6V284.5a2.593,2.593,0,0,0,2.6,2.59h22.26a2.6,2.6,0,0,0,2.6-2.59v-22.27a2.608,2.608,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_19"
              data-name="Path 19"
              d="M742.109,297.585h-22.26a2.6,2.6,0,0,0-2.6,2.6v22.27a2.592,2.592,0,0,0,2.6,2.59h22.26a2.6,2.6,0,0,0,2.6-2.59v-22.27A2.608,2.608,0,0,0,742.109,297.585Z"
              transform="translate(-576.969 -259.635)"
              fill="#fff"
            />
            <path
              id="Path_20"
              data-name="Path 20"
              d="M742.109,335.535h-22.26a2.6,2.6,0,0,0-2.6,2.6V360.4a2.595,2.595,0,0,0,2.6,2.6h22.26a2.6,2.6,0,0,0,2.6-2.6v-22.26A2.608,2.608,0,0,0,742.109,335.535Z"
              transform="translate(-576.969 -259.635)"
              fill="#fff"
            />
            <path
              id="Path_21"
              data-name="Path 21"
              d="M742.109,373.485h-22.26a2.6,2.6,0,0,0-2.6,2.6v22.26a2.595,2.595,0,0,0,2.6,2.6h22.26a2.6,2.6,0,0,0,2.6-2.6v-22.26A2.608,2.608,0,0,0,742.109,373.485Z"
              transform="translate(-576.969 -259.635)"
              fill="#e6e6e6"
            />
            <path
              id="Path_22"
              data-name="Path 22"
              d="M742.109,411.435h-22.26a2.595,2.595,0,0,0-2.6,2.6V436.3a2.6,2.6,0,0,0,2.6,2.6h22.26a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.6,2.6,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_23"
              data-name="Path 23"
              d="M788.869,259.635H766.6a2.6,2.6,0,0,0-2.59,2.6V284.5a2.59,2.59,0,0,0,2.59,2.59h22.27a2.6,2.6,0,0,0,2.6-2.59v-22.27a2.608,2.608,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#fff"
            />
            <path
              id="Path_24"
              data-name="Path 24"
              d="M788.869,297.585H766.6a2.6,2.6,0,0,0-2.59,2.6v22.27a2.59,2.59,0,0,0,2.59,2.59h22.271a2.6,2.6,0,0,0,2.6-2.59v-22.27A2.608,2.608,0,0,0,788.869,297.585Z"
              transform="translate(-576.969 -259.635)"
              fill="#fff"
            />
            <path
              id="Path_25"
              data-name="Path 25"
              d="M788.869,335.535H766.6a2.6,2.6,0,0,0-2.59,2.6V360.4a2.593,2.593,0,0,0,2.59,2.6h22.27a2.6,2.6,0,0,0,2.6-2.6v-22.26A2.608,2.608,0,0,0,788.869,335.535Z"
              transform="translate(-576.969 -259.635)"
              fill="#fff"
            />
            <path
              id="Path_26"
              data-name="Path 26"
              d="M788.869,373.485H766.6a2.6,2.6,0,0,0-2.59,2.6v22.26a2.593,2.593,0,0,0,2.59,2.6h22.27a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.608,2.608,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_27"
              data-name="Path 27"
              d="M788.869,411.435H766.6a2.593,2.593,0,0,0-2.59,2.6V436.3a2.593,2.593,0,0,0,2.59,2.6h22.27a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.6,2.6,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#e6e6e6"
            />
            <path
              id="Path_28"
              data-name="Path 28"
              d="M835.629,259.635h-22.27a2.6,2.6,0,0,0-2.59,2.6V284.5a2.59,2.59,0,0,0,2.59,2.59h22.271a2.6,2.6,0,0,0,2.6-2.59v-22.27A2.608,2.608,0,0,0,835.629,259.635Z"
              transform="translate(-576.969 -259.635)"
              fill="#fff"
            />
            <path
              id="Path_29"
              data-name="Path 29"
              d="M835.629,297.585h-22.27a2.6,2.6,0,0,0-2.59,2.6v22.27a2.59,2.59,0,0,0,2.589,2.59h22.271a2.6,2.6,0,0,0,2.6-2.59v-22.27A2.608,2.608,0,0,0,835.629,297.585Z"
              transform="translate(-576.969 -259.635)"
              fill="#fff"
            />
            <path
              id="Path_30"
              data-name="Path 30"
              d="M835.629,335.535h-22.27a2.6,2.6,0,0,0-2.59,2.6V360.4a2.593,2.593,0,0,0,2.59,2.6h22.27a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.608,2.608,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_31"
              data-name="Path 31"
              d="M835.629,373.485h-22.27a2.6,2.6,0,0,0-2.59,2.6v22.26a2.593,2.593,0,0,0,2.59,2.6h22.27a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.608,2.608,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#e6e6e6"
            />
            <path
              id="Path_32"
              data-name="Path 32"
              d="M835.629,411.435h-22.27a2.593,2.593,0,0,0-2.59,2.6V436.3a2.593,2.593,0,0,0,2.59,2.6h22.27a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.6,2.6,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#fff"
            />
            <path
              id="Path_33"
              data-name="Path 33"
              d="M882.389,259.635h-22.27a2.6,2.6,0,0,0-2.59,2.6V284.5a2.59,2.59,0,0,0,2.59,2.59h22.271a2.6,2.6,0,0,0,2.6-2.59v-22.27A2.608,2.608,0,0,0,882.389,259.635Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_34"
              data-name="Path 34"
              d="M882.389,297.585h-22.27a2.6,2.6,0,0,0-2.59,2.6v22.27a2.59,2.59,0,0,0,2.589,2.59h22.271a2.6,2.6,0,0,0,2.6-2.59v-22.27A2.608,2.608,0,0,0,882.389,297.585Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_35"
              data-name="Path 35"
              d="M882.389,335.535h-22.27a2.6,2.6,0,0,0-2.59,2.6V360.4a2.592,2.592,0,0,0,2.59,2.6h22.27a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.608,2.608,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#e6e6e6"
            />
            <path
              id="Path_36"
              data-name="Path 36"
              d="M882.389,373.485h-22.27a2.6,2.6,0,0,0-2.59,2.6v22.26a2.593,2.593,0,0,0,2.59,2.6h22.27a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.608,2.608,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#fff"
            />
            <path
              id="Path_37"
              data-name="Path 37"
              d="M882.389,411.435h-22.27a2.593,2.593,0,0,0-2.59,2.6V436.3a2.593,2.593,0,0,0,2.59,2.6h22.27a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.6,2.6,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_38"
              data-name="Path 38"
              d="M929.149,259.635h-22.27a2.6,2.6,0,0,0-2.59,2.6V284.5a2.591,2.591,0,0,0,2.59,2.59h22.27a2.6,2.6,0,0,0,2.6-2.59v-22.27A2.608,2.608,0,0,0,929.149,259.635Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_39"
              data-name="Path 39"
              d="M929.149,297.585h-22.27a2.6,2.6,0,0,0-2.59,2.6v22.27a2.59,2.59,0,0,0,2.589,2.59h22.271a2.6,2.6,0,0,0,2.6-2.59v-22.27A2.608,2.608,0,0,0,929.149,297.585Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_40"
              data-name="Path 40"
              d="M929.149,335.535h-22.27a2.6,2.6,0,0,0-2.59,2.6V360.4a2.592,2.592,0,0,0,2.59,2.6h22.27a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.608,2.608,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#e6e6e6"
            />
            <path
              id="Path_41"
              data-name="Path 41"
              d="M929.149,373.485h-22.27a2.6,2.6,0,0,0-2.59,2.6v22.26a2.593,2.593,0,0,0,2.59,2.6h22.27a2.6,2.6,0,0,0,2.6-2.6v-22.26A2.608,2.608,0,0,0,929.149,373.485Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_42"
              data-name="Path 42"
              d="M929.149,411.435h-22.27a2.593,2.593,0,0,0-2.59,2.6V436.3a2.593,2.593,0,0,0,2.59,2.6h22.27a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.6,2.6,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_43"
              data-name="Path 43"
              d="M975.909,259.635h-22.27a2.6,2.6,0,0,0-2.59,2.6V284.5a2.59,2.59,0,0,0,2.59,2.59h22.27a2.6,2.6,0,0,0,2.6-2.59v-22.27A2.608,2.608,0,0,0,975.909,259.635Z"
              transform="translate(-576.969 -259.635)"
              fill="#e6e6e6"
            />
            <path
              id="Path_44"
              data-name="Path 44"
              d="M975.909,297.585h-22.27a2.6,2.6,0,0,0-2.59,2.6v22.27a2.59,2.59,0,0,0,2.59,2.59h22.271a2.6,2.6,0,0,0,2.6-2.59v-22.27A2.608,2.608,0,0,0,975.909,297.585Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_45"
              data-name="Path 45"
              d="M975.909,335.535h-22.27a2.6,2.6,0,0,0-2.59,2.6V360.4a2.592,2.592,0,0,0,2.59,2.6h22.27a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.608,2.608,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_46"
              data-name="Path 46"
              d="M975.909,373.485h-22.27a2.6,2.6,0,0,0-2.59,2.6v22.26a2.593,2.593,0,0,0,2.59,2.6h22.27a2.6,2.6,0,0,0,2.6-2.6v-22.26A2.608,2.608,0,0,0,975.909,373.485Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_47"
              data-name="Path 47"
              d="M975.909,411.435h-22.27a2.593,2.593,0,0,0-2.59,2.6V436.3a2.593,2.593,0,0,0,2.59,2.6h22.27a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.6,2.6,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#e6e6e6"
            />
            <path
              id="Path_48"
              data-name="Path 48"
              d="M1022.67,259.635H1000.4a2.6,2.6,0,0,0-2.59,2.6V284.5a2.591,2.591,0,0,0,2.589,2.59h22.271a2.6,2.6,0,0,0,2.6-2.59v-22.27a2.608,2.608,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#e6e6e6"
            />
            <path
              id="Path_49"
              data-name="Path 49"
              d="M1022.67,297.585H1000.4a2.6,2.6,0,0,0-2.59,2.6v22.27a2.591,2.591,0,0,0,2.59,2.59h22.271a2.6,2.6,0,0,0,2.6-2.59v-22.27a2.608,2.608,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#e6e6e6"
            />
            <path
              id="Path_50"
              data-name="Path 50"
              d="M1022.67,335.535H1000.4a2.6,2.6,0,0,0-2.59,2.6V360.4a2.593,2.593,0,0,0,2.59,2.6h22.27a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.608,2.608,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#536dfe"
            />
            <path
              id="Path_51"
              data-name="Path 51"
              d="M1022.67,373.485H1000.4a2.6,2.6,0,0,0-2.59,2.6v22.26a2.593,2.593,0,0,0,2.59,2.6h22.27a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.608,2.608,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#e6e6e6"
            />
            <path
              id="Path_52"
              data-name="Path 52"
              d="M1022.67,411.435H1000.4a2.593,2.593,0,0,0-2.59,2.6V436.3a2.593,2.593,0,0,0,2.59,2.6h22.27a2.6,2.6,0,0,0,2.6-2.6v-22.26a2.6,2.6,0,0,0-2.6-2.6Z"
              transform="translate(-576.969 -259.635)"
              fill="#e6e6e6"
            />
          </g>
          <path
            id="Path_53"
            data-name="Path 53"
            d="M336.1,660.051h-.62l.53-.07Z"
            fill="#2f2e41"
          />
          <g id="body" transform="translate(106.83 340.85)">
            <path
              id="Path_2"
              data-name="Path 2"
              d="M594.309,820.325q-3.975.09-7.98.09c-63.43,0-143.21-33.88-215.61-80.78q-8.985-5.82-17.81-11.91l5.16-31.4,156.21-20.74,78.4,59.95Z"
              transform="translate(-338.029 -349.005)"
              fill="#2f2e41"
            />
            <path
              id="Path_54"
              data-name="Path 54"
              d="M634.279,424.7l-.22,1.16-2.47,13.04-17.07,90.2-1.01,5.31-2.12,11.23-2.9,15.32-6.43,33.95-1.84,9.73-.69,3.65-.24,1.28-1.91,10.07-.58,3.04-4.66,34.53-4.07,30.09,13.62,13.62-8.12,8.12-5.33,30.53.01.07H370.719q-13.2-8.55-26.02-17.63l1.79-13.4s6.16-23.93,3.57-26.79-8.24-7.97-8.24-7.97l7.13-16.64.99-2.31-1.66-34.43-.04-.83-.55-11.35-.07-1.46-.11-2.19-2.11-43.68-.04-.72-.64-13.24-.6-12.59-.26-5.31-2.57-53.13-1.74-36.08-1.52-31.41,6.11-2.07,65.35-22.21L436.559,349l56.34.42,27.58.21,46.02,42.68,10.47,5,.08.04,7.51,3.59,19.04,9.09,20.13,9.62,10.33,4.93Z"
              transform="translate(-338.029 -349.005)"
              fill="#cacaca"
            />
          </g>
          <g id="left-arm" transform="translate(-24.828 382.181)">
            <path
              id="Path_55"
              data-name="Path 55"
              d="M443.84,637.136a30.286,30.286,0,0,1-40.664-22.43L296.617,599.588l37.043-41.9,95.511,20.78a30.45,30.45,0,0,1,14.669,58.67Z"
              transform="translate(-234.283 -389.922)"
              fill="#ffb6b6"
            />
            <path
              id="Path_56"
              data-name="Path 56"
              d="M396.329,560.955a13.522,13.522,0,0,0-7.89-4.87l-43.72-9.09-4.49-.93a18.933,18.933,0,0,1-12.53-9.07,19.16,19.16,0,0,1-2.45-7.9,18.9,18.9,0,0,1,.89-7.48l15.15-45.65,9.83-29.62a41.794,41.794,0,0,0,2.09-11.05,43.349,43.349,0,0,0-9.07-28.89,42.693,42.693,0,0,0-49.01-13.64c-.25.09-.51.19-.76.29a42.583,42.583,0,0,0-25.31,28.41l-10.68,38.85-22.03,80.09a57.766,57.766,0,0,0,48.96,72.68l62.97,7.38,29.14,3.42a13.5,13.5,0,0,0,14.84-10.73,4.9,4.9,0,0,0,.11-.55l.7-4.32,5.93-36.38.06-.37a13.475,13.475,0,0,0-2.73-10.58Z"
              transform="translate(-234.283 -389.922)"
              fill="#cacaca"
            />
          </g>
          <g id="right-arm" transform="translate(192.855 370.32)">
            <path
              id="Path_57"
              data-name="Path 57"
              d="M508.955,630.617c3.361.78,9.771.4,13.418,0,5.063-.553,10.008,5.691,14.411,2.375a30.286,30.286,0,0,0,12.024-22.63L652.17,580.368l-42.581-36.259-91.626,34.042a30.45,30.45,0,0,0-29.842,27.3c-1.594,15.346,5.783,21.775,20.834,25.167Z"
              transform="translate(-487.907 -349.616)"
              fill="#ffb6b6"
            />
            <path
              id="Path_58"
              data-name="Path 58"
              d="M703.489,513.275l-49.16-113.14a42.819,42.819,0,0,0-20.27-21.35,43.357,43.357,0,0,0-8.78-3.2c-.47-.12-.94-.23-1.41-.32a42.132,42.132,0,0,0-19.48.36,42.813,42.813,0,0,0-27.34,21.73,1,1,0,0,0-.08.14,43.1,43.1,0,0,0-.37,38.85l.61,1.22,34.74,69.77a18.9,18.9,0,0,1-10.5,26.19l-2.44.88-43.88,15.85a13.5,13.5,0,0,0-8.33,16.79l.11.35,12.3,39.36c.06.18.12.36.19.54a7.052,7.052,0,0,0,.4.99,13.482,13.482,0,0,0,15.81,7.53l23.68-6.25,4.83-1.28,61.15-16.15a57.76,57.76,0,0,0,38.22-78.86Z"
              transform="translate(-420.907 -374.296)"
              fill="#cacaca"
            />
          </g>
          <path
            id="Path_60"
            data-name="Path 60"
            d="M842.759,711.025q-5.745,6.015-11.8,11.74h-96.21v-11.74Z"
            transform="translate(-174.731 -79.585)"
            fill="#fff"
          />
          <g id="Table" transform="translate(-1.975 320.85)">
            <path
              id="Path_59"
              data-name="Path 59"
              d="M219.629,608.285c14.171,17.284,37.15,41.595,53.447,56.889L728,663.764c9.067.014,5.764.8,5.773,9.871l.65,114.53a355.427,355.427,0,0,0,77.47-48.53q9.84-8.085,19.07-16.87,6.045-5.73,11.8-11.74a355.627,355.627,0,0,0,68.82-102.74Z"
              transform="translate(-219.629 -329.635)"
              fill="#3f3d56"
            />
            <path
              id="Path_62"
              data-name="Path 62"
              d="M274.147,535.179v28.187c0,.184,24.293,0,28.348,0H427.676v51.958h-1.663a1.039,1.039,0,0,0-.994,1.08v3.614a1.039,1.039,0,0,0,.994,1.08h77.71a1.039,1.039,0,0,0,.994-1.08V616.4a1.039,1.039,0,0,0-.994-1.08H502.06V563.366H660.568V533.278Z"
              transform="translate(-221.887 -339.686)"
              fill="#3f3d56"
            />
            <circle
              id="Ellipse_1"
              data-name="Ellipse 1"
              cx="31.306"
              cy="31.306"
              r="31.306"
              transform="translate(207.699 64.348)"
              fill="#2978b5"
            />
            <path
              id="Path_61"
              data-name="Path 61"
              d="M680.775,335.547a6.485,6.485,0,0,0-5.552-2.912H301.445c-3.489.008-6.313,2.5-6.316,5.573V535.232H681.55V338.208A4.909,4.909,0,0,0,680.775,335.547Z"
              transform="translate(-242.87 -332.635)"
              fill="#3f3d56"
            />
          </g>
          <g id="head" transform="translate(110.83 144.918)">
            <path
              id="Path_66"
              data-name="Path 66"
              d="M548.729,255.355l-1.97-14.56a15.71,15.71,0,0,0-5-9.56l4.53,33.37a6.175,6.175,0,0,0,.41,1.56,16.748,16.748,0,0,0,2.03-10.81Z"
              transform="translate(-364.561 -153.637)"
              fill="#3f3d56"
            />
            <ellipse
              id="Ellipse_4"
              data-name="Ellipse 4"
              cx="2.5"
              cy="7"
              rx="2.5"
              ry="7"
              transform="translate(180.237 87.669) rotate(-7.726)"
              fill="#3f3d56"
            />
            <g id="head-2" data-name="head" transform="translate(0 0)">
              <circle
                id="ab6171fa-7d69-4734-b81c-8dff60f9761b"
                cx="68.322"
                cy="68.322"
                r="68.322"
                transform="translate(24.662 34.36)"
                fill="#ffb6b6"
              />
              <path
                id="bf427902-b9bf-4946-b5d7-5c1c7e04535e"
                d="M517.377,206.226s17.869-34.161-21.444-37.266c0,0-33.515-30.4-67.676-5.558,0,0-18.633,0-28.823,21.086,0,0-14.655-5.558-17.875,9.317,0,0-10.724,31.055,0,59.005s14.285,31.055,14.285,31.055-17.621-58.6,25.27-61.7,90.887-29.909,94.461,4.251,8.953,42.578,8.953,42.578S558.479,220.2,517.377,206.226Z"
                transform="translate(-364.561 -153.637)"
                fill="#725138"
              />
              <path
                id="Path_63"
                data-name="Path 63"
                d="M540.4,252.585h-5c0-37.8-37.41-62.57-75.15-62.59a82.384,82.384,0,0,0-16.35,1.59c-6.06,1.21-12.35,2.66-18.53,4.55-24.37,7.47-46.97,21.91-46.97,56.45a78.589,78.589,0,0,0,2.54,19.88l-4.84,1.26a83.875,83.875,0,0,1-2.7-21.14c0-30.18,12.39-50.91,33.79-63.27,11.25-6.5,24.98-10.69,40.71-12.73a97.131,97.131,0,0,1,19.75-.6C511.049,179.1,540.4,212.385,540.4,252.585Z"
                transform="translate(-364.561 -153.637)"
                fill="#2978b5"
              />
              <path
                id="Path_64"
                data-name="Path 64"
                d="M548.729,255.355l-1.97-14.56a15.914,15.914,0,0,0-18.25-13.56l-3.13.43a6.581,6.581,0,0,0-5.64,7.4l4.55,33.54a6.577,6.577,0,0,0,5.3,5.57,6.154,6.154,0,0,0,1.22.12,6.49,6.49,0,0,0,.879-.06l3.5-.47a15.792,15.792,0,0,0,10.74-6.43c.27-.38.53-.77.77-1.17A16.749,16.749,0,0,0,548.729,255.355Z"
                transform="translate(-364.561 -153.637)"
                fill="#2978b5"
              />
              <path
                id="Path_65"
                data-name="Path 65"
                d="M523.359,228.275a6.431,6.431,0,0,0-2.33,1.92,6.548,6.548,0,0,0-1.29,4.87l4.55,33.54a6.577,6.577,0,0,0,5.3,5.57Z"
                transform="translate(-364.561 -153.637)"
                fill="#fff"
              />
              <ellipse
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="2.5"
                cy="7"
                rx="2.5"
                ry="7"
                transform="translate(164.237 98.669) rotate(-7.726)"
                fill="#3f3d56"
              />
              <ellipse
                id="Ellipse_3"
                data-name="Ellipse 3"
                cx="2.5"
                cy="7"
                rx="2.5"
                ry="7"
                transform="translate(161.237 80.669) rotate(-7.726)"
                fill="#3f3d56"
              />
              <path
                id="Path_67"
                data-name="Path 67"
                d="M460.249,189.995a82.383,82.383,0,0,0-16.35,1.59c-6.06,1.21-12.35,2.66-18.53,4.55-9.65-.47-16.75-2.97-18.18-6.82,11.25-6.5,24.98-10.69,40.71-12.73a97.132,97.132,0,0,1,19.75-.6,5.727,5.727,0,0,1,2.72,3.82C470.839,183.285,466.869,186.985,460.249,189.995Z"
                transform="translate(-364.561 -153.637)"
                fill="#3f3d56"
              />
              <path
                id="Path_68"
                data-name="Path 68"
                d="M396.409,287.285l-7.7-32.01a6.024,6.024,0,0,0-4.88-4.55,6.734,6.734,0,0,0-1-.08,6.027,6.027,0,0,0-1.4.17l-2.98.72a14.9,14.9,0,0,0-10.99,17.96l3.45,14.36a15.845,15.845,0,0,0,5.34,8.62,14.048,14.048,0,0,0,1.36.97,14.809,14.809,0,0,0,11.37,1.84l2.97-.72a5.84,5.84,0,0,0,2.17-1.01,5.993,5.993,0,0,0,2.29-6.27Z"
                transform="translate(-364.561 -153.637)"
                fill="#2978b5"
              />
              <ellipse
                id="Ellipse_5"
                data-name="Ellipse 5"
                cx="2.5"
                cy="7"
                rx="2.5"
                ry="7"
                transform="translate(10 114.668) rotate(-13.53)"
                fill="#3f3d56"
              />
              <ellipse
                id="Ellipse_6"
                data-name="Ellipse 6"
                cx="2.5"
                cy="7"
                rx="2.5"
                ry="7"
                transform="translate(0 117.668) rotate(-13.53)"
                fill="#3f3d56"
              />
              <path
                id="Path_69"
                data-name="Path 69"
                d="M396.9,287.165l-7.7-32.01a6.532,6.532,0,0,0-5.29-4.92l10.51,43.72a6.511,6.511,0,0,0,2.48-6.79Z"
                transform="translate(-364.561 -153.637)"
                fill="#fff"
              />
              <path
                id="Path_70"
                data-name="Path 70"
                d="M369.2,263.155a6.476,6.476,0,0,0-1.17-2.45,14.725,14.725,0,0,0-.57,8.79l3.45,14.36a15.845,15.845,0,0,0,5.34,8.62Z"
                transform="translate(-364.561 -153.637)"
                fill="#3f3d56"
              />
            </g>
          </g>
        </g>
        <g id="coffe" transform="translate(716.514 572.68)">
          <g id="Smoke-big" transform="translate(21.436)">
            <path
              id="eptcVe7QwMa4"
              d="M6.05,65.5h0c-2.14-12.473-3.764-2.851-1.633-42.2C4.785,21.451,5.6,9.747,6.05,0h0C-3.008,18.53-.962,41.976,6.05,65.5Z"
              transform="translate(0 0.561) rotate(-5.318)"
              fill="#b3b3b3"
            />
          </g>
          <g id="Smoke-small" transform="translate(32.226 13.396)">
            <path
              id="eptcVe7QwMa5"
              d="M871.205,567.013h0c-1-8.333-.786-25.116-.786-25.116l.786-13.874h0C866.192,540.049,867.207,554.007,871.205,567.013Z"
              transform="translate(-867.815 -528.023)"
              fill="#a5a5a5"
            />
          </g>
          <path
            id="eptcVe7QwMa6"
            d="M902.4,584.17v7.8a2.353,2.353,0,0,1-2.34,2.34h-3.9a.777.777,0,0,0-.78.779V659.03a2.352,2.352,0,0,1-2.339,2.34H845.476a2.342,2.342,0,0,1-2.34-2.34V595.087a.781.781,0,0,0-.779-.779h-4.679a2.341,2.341,0,0,1-2.339-2.34v-7.8a2.335,2.335,0,0,1,2.339-2.339h62.383A2.347,2.347,0,0,1,902.4,584.17Z"
            transform="translate(-835.339 -522.607)"
            fill="#cacaca"
          />
          <path
            id="eptcVe7QwMa8"
            d="M895.383,630.369c-17.483,7.235-35.157,7.314-53.026,0V613.888a83.272,83.272,0,0,1,53.026,0Z"
            transform="translate(-835.339 -518.335)"
            fill="#2978b5"
          />
          <rect
            id="eptcVe7QwMa7"
            width="52.246"
            height="2.339"
            transform="translate(7.798 72.61)"
            fill="#e6e6e6"
          />
        </g>
        <g
          id="Ellipse_7"
          data-name="Ellipse 7"
          transform="translate(365 500)"
          fill="#2978b5"
          stroke="#707070"
          stroke-width="1"
        >
          <circle cx="23" cy="23" r="23" stroke="none" />
          <circle cx="23" cy="23" r="22.5" fill="none" />
        </g>
      </g>
    </svg>
  );
};

export default BackgroundPattern;
